<template>
  <div>
    <v-row justify="space-between">
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <h1 class="headline font-weight-light">Onsite Case</h1>
      </v-col>
      <v-col cols="12" sm="12" md="6" class="fix-flex-end-row">
        <v-text-field
          class="ma-0"
          v-model="form.searchtext"
          clearable
          dense
          rounded
          outlined
          @input="
            chk_active_btn = 0;
            pagination.current = 1;
            getCase();
          "
        >
          <template v-slot:label>
            <v-icon style="vertical-align: middle">mdi-magnify</v-icon>Case ID /
            Serial / Site Name / PO Number
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters class="mb-2">
      <v-col v-if="projects.length >= 1" cols="12" md="4">
        <v-select
          class="pr-3"
          :items="projects"
          v-model="form.projects"
          item-text="project_name"
          item-value="project_id"
          multiple
          outlined
          dense
          clearable
          @blur="get_data()"
        >
          <template v-slot:label>
            <v-icon small class="mb-1" style="vertical-align: middle"
              >mdi-filter</v-icon
            >Filter Project
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index < 3">
              <span>{{ item.project_name }}</span>
            </v-chip>
            <span v-if="index === 3" class="grey--text caption">
              (+{{ form.projects.length - 3 }}
              others)
            </span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          class="pr-3"
          :items="product_group"
          v-model="form.product_group"
          multiple
          outlined
          dense
          clearable
          @blur="get_data()"
        >
          <template v-slot:label>
            <v-icon small class="mb-1" style="vertical-align: middle"
              >mdi-filter</v-icon
            >Filter Product
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index < 3">
              <span>{{ item }}</span>
            </v-chip>
            <span v-if="index === 3" class="grey--text caption">
              (+{{ form.product_group.length - 3 }}
              others)
            </span>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <table-view-case
      @getCase="getCase"
      :condition="condition"
      :data_case="data_case"
      :casetab="casetab"
    />
    <div class="text-center pa-5">
      <v-pagination
        @input="onPageChange"
        v-model="pagination.current"
        :length="data_case.last_page"
        total-visible="10"
        circle
      ></v-pagination>
    </div>
    <div id="snackbar" class="d-print-none">
      <v-snackbar v-model="snackbar" color="success" right>{{
        text
      }}</v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import { mapState, mapMutations } from "vuex";

import TableViewCase from "../components/TableViewCase";
import MaterialStatsCard from "../../../components/StatsCard";
import ViewCdax from "../../../components/ViewCdax";
export default {
  components: {
    "view-cdax": ViewCdax,
    "table-view-case": TableViewCase,
    "base-material-stats-card": MaterialStatsCard,
  },
  computed: {
    ...mapState(["snackbar"]),
    ...mapState(["isLoading"]),
  },
  mounted() {
    this.getCase();
    this.getProject();
  },
  data() {
    return {
      text: "Success, Your work has been saved",
      caseid: 0,
      advanced_filter: false,
      autolog: "",
      data_pickup: [],
      status_log: null,
      text_copy: "",
      reasonR: [(v) => !!v || "Reason is required"],
      valid: false,
      reason: "",
      buttonstatus: "",
      maincase_id_changestatus: 0,
      dialogchangestatus: false,
      dialogconfirm: false,
      no: 1,
      data: [],
      condition: {
        team: this.$route.params.team,
        status: "OnsiteBench",
      },
      search: "",
      url: process.env.VUE_APP_ROOT_API,
      data_case: [],
      form: {
        projects: [],
        searchtext: "",
        product_group: [],
      },
      projects: [],
      pagination: {
        current: 1,
      },
      data_summary: [],
      arr_card: [],
      chk_active_btn: 0,
      num_total: 0,
      product_group: [],
      casetab: false,
    };
  },
  methods: {
    ...mapMutations(["mutatesnackbar"]),
    ...mapMutations(["mutateIsLoading"]),
    get_data: _.debounce(async function (e) {
      this.chk_active_btn = 0;
      this.form.status = "";
      this.form.searchtext = "";
      this.getCase();

      if (this.form.branchs.length == 0) {
        this.visibleengineerbkk = false;
      }
    }, 1500),
    getCase: _.debounce(async function (e) {
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      const url = `${process.env.VUE_APP_ROOT_API}/api/view-assigned-bkk?page=${this.pagination.current}`;
      try {
        // this.mutateIsLoading();
        const { data } = await axios.post(`${url}`, this.form, options);
        this.pagination.current = data.current_page;
        this.data_case = data;
        this.casetab = true;
        // console.log(this.form)
        // this.mutateIsLoading();
      } catch (error) {
        console.log(error);
      }
    }, 1000),
    async getProject() {
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      const url = `${process.env.VUE_APP_ROOT_API}/api/get-filtercase-bkk`;
      try {
        const { data } = await axios.get(`${url}`, options);
        this.projects = data.projects;
        this.product_group = data.product_group;
      } catch (error) {}
    },
    onPageChange() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      this.getCase();
    },
  },
};
</script>
<style>
.v-input__slot {
  margin-left: 0px !important;
}
</style>
